import isBetween from 'dayjs/plugin/isBetween.js';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

export default defineNuxtPlugin(() => {
  dayjs.extend(utc);
  dayjs.extend(isBetween);
  dayjs.locale('ru');
});
